export const G3dResolution = {
    AUTO: 0,
    '200K': 200000,
    '180K': 180000,
    '160K': 160000,
    '140K': 140000,
    '120K': 120000,
    '100K': 100000,
    '80K': 80000,
    '60K': 60000,
    '40K': 40000,
    '20K': 20000
};

export enum RegionMode {
    REGION = 'REGION',
    CHROMOSOME = 'CHROMOSOME',
    GENOME = 'GENOME'
}
